import MainPage from "./components/MainPage";
import { BrowserRouter, Route, Routes, useNavigate } from "react-router-dom";
import Login, { LoginContext, useLogin } from "./components/Login";
import NoMatch from "./components/NoMatch";
import BamboraCheckout from "./components/BamboraCheckout";
import NavBar from "./components/NavBar";
import Orders from "./components/Orders/Orders";
import Authorized from "./components/Authorized";
import { useContext, useEffect, useState } from "react";
import APIContext from "./hooks/API";
import { T } from "./components/traks";
import ShowOrder from "./components/Orders/ShowOrder";
import SwaggerUI from "swagger-ui-react";
import "swagger-ui-react/swagger-ui.css";

function App() {
	const loginCtx = useLogin();
	return (
		<LoginContext.Provider value={loginCtx}>
			<BrowserRouter>
				{!!loginCtx.user && <NavBar />}
				{!!loginCtx.user && !loginCtx.useMFA && <MFAWarning />}
				<Routes>
					<Route exact path="/" element={<Landing />} />
					<Route
						path="/home"
						element={
							<Authorized>
								<MainPage />
							</Authorized>
						}
					/>
					<Route path="/login" element={<Login />} />
					<Route
						path="/orders"
						element={
							<Authorized>
								<Orders />
							</Authorized>
						}
					/>
					<Route
						path="/orders/:companyId/:orderId"
						element={
							<Authorized>
								<ShowOrder />
							</Authorized>
						}
					/>
					<Route path="/bamboraCheckout" element={<BamboraCheckout />} />
					<Route
						path="/docs"
						element={
							<Authorized>
								<SwaggerDocs />
							</Authorized>
						}
					/>
					<Route path="*" element={<NoMatch />} />
				</Routes>
			</BrowserRouter>
		</LoginContext.Provider>
	);
}

const MFAWarning = () => {
	const [dismissed, setDismissed] = useState(false);
	const navigate = useNavigate();

	if (dismissed) return null;

	return (
		<div
			className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
			style={{ zIndex: 1050, backgroundColor: "rgba(0,0,0,0.5)" }}
		>
			<div
				className="bg-white rounded shadow p-4"
				style={{ maxWidth: 450, width: "90%" }}
			>
				<h5 className="text-warning mb-3">
					<T>Two-Factor Authentication is not enabled</T>
				</h5>
				<p>
					<T>
						Your account does not have two-factor authentication
						enabled. We strongly recommend enabling it to secure
						your account.
					</T>
				</p>
				<div className="d-flex justify-content-end gap-2">
					<button
						className="btn btn-outline-secondary btn-sm"
						onClick={() => setDismissed(true)}
					>
						<T>Dismiss</T>
					</button>
					<button
						className="btn btn-primary btn-sm"
						onClick={() => {
							setDismissed(true);
							navigate("/home");
						}}
					>
						<T>Enable now</T>
					</button>
				</div>
			</div>
		</div>
	);
};

const Landing = () => {
	const { authToken } = useContext(APIContext);
	const navigate = useNavigate();
	useEffect(() => {
		if (authToken) navigate("/home");
	}, [authToken, navigate]);
	console.log("Landing");
	return <Login />;
};

const SwaggerDocs = () => {
	return <SwaggerUI url="api.yaml" />;
};

export default App;
